import React from 'react';

/*
    - ihoDesignSystem
*/
import { Grid, Typography } from '@iho-design-system/Loader';

const Toolbar = () => {

    return (
        <React.Fragment>
            <Grid>
                <Grid.Wrapper>
                    <Grid.Item
                        size='col-12'>
                        <Typography
                            component='h4'
                            ms={{
                                fontWeight: 'normal !important'
                            }}>
                            سازمان‌های زیرمجموعه
                        </Typography>
                        <Typography
                            className={`d-block`}
                            component='p'
                            ms={{
                                color: '#6F6F7E'
                            }}>
                                 می توانید سازمان‌های زیرمجموعه خود را، در لیست زیر مشاهده نمایید.
                        </Typography>
                    </Grid.Item>
                </Grid.Wrapper>
            </Grid>
        </React.Fragment>
    );

}

export default Toolbar;